import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

require("babel-polyfill")
import VueHtml2Canvas from 'vue-html2canvas'

Vue.config.productionTip = false


import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

// Require in a base component context
const requireComponent = require.context(
    './components/viewers', true, /[\w-]+\.vue$/
);
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    const componentName = upperFirst(
        camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    );
    Vue.component(componentName, componentConfig.default || componentConfig)
});

//Vue.use(VueHtml2Canvas);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

if (ga !== undefined) {
    ga('set', 'page', router.currentRoute.path);
    ga('send', 'pageview');

    router.afterEach((to, from) => {
        ga('set', 'page', to.path);
        ga('send', 'pageview');
    });
}
